import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import Home from './layout/Home';
import ProductDetail from './layout/product/Productdetail';
import Login from './layout/LoginComponent';
import Backend from './layout/backend/Backend';
import Cart from './page/Cart.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Terms from './layout/Footer/Terms.jsx';
import Privacy from './layout/Footer/Privacy.jsx';
import Refund from './layout/Footer/Refund.jsx';
import Shipping from './layout/Footer/Shipping.jsx';
import CheckOut from './page/CheckOut.jsx';
function App() {
  
  return (
    <Provider store={store}>
      <ToastContainer/>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:ProductName" element={<ProductDetail />} />
          <Route path='/cart' element={<Cart />} />
          <Route path="/login" element={<Login />} />
          <Route path='/backend' element={<Backend />} />
          <Route path='/terms' element={<Terms/>}/>
          <Route path='/privacy' element={<Privacy/>}/>
          <Route path='/refund' element={<Refund/>}/>
          <Route path='/shipping' element={<Shipping/>}/>
          <Route path='/checkout' element={<CheckOut/>}/>
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;

